import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import Link from 'next/link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { CmsPageContext } from '../../pages/[...path]';

const Breadcrumbs = () => {
  const { menuItems, pageTitle } = useContext(CmsPageContext);

  const { pathname } = window.location;

  const slicedPathname = pathname.slice(1);

  const getBreadCrumbsToRender = () => {
    const slicedPathname = pathname.slice(1);
    const pathnameArray = slicedPathname.split('/');

    let breadcrumbsArrObj = [{ label: 'Home', path: '/' }];

    pathnameArray.forEach((subPath, indexSubPath) => {
      let pathFindedInMenuItems = false;
      menuItems.forEach(mItem => {
        if (mItem?.page?.path === subPath) {
          breadcrumbsArrObj.push({ label: mItem.name, path: mItem.page.path });
          pathFindedInMenuItems = true;
          return;
        }

        // find path is in second menu level
        mItem?.subItems?.forEach(subMenuItem => {
          if (subMenuItem?.page?.path === subPath) {
            breadcrumbsArrObj.push({ label: mItem.name, path: mItem.page.path });
            pathFindedInMenuItems = true;
          }
        });
      });

      // if is last subPath and isn't find in menu -> create last element in breadcrumbsArrObj based on pageTitle prop
      if (indexSubPath === pathnameArray?.length - 1 && !pathFindedInMenuItems) {
        breadcrumbsArrObj.push({ label: pageTitle, path: slicedPathname });
      }
    });

    return breadcrumbsArrObj;
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {getBreadCrumbsToRender()?.map((bread, index) => (
        <Box key={`${bread.label}-${bread.path}`} style={{display: 'flex', alignItems: 'center', }}>
          {index > 0 && <NavigateNextIcon />}
          <Link
            href={bread.path}
            title={bread.label}
            style={{ textDecoration: 'none !important' }}
          >
            <span>{bread.label}</span>
          </Link>
        </Box>
      ))}
    </Box>
  );
};

export default Breadcrumbs;
